import Vue from 'vue'

export const userKey = '__manager_user_naweservice_store'
export const companykey = '__manager_company_store'
export const searchglobalkey = '__manager_searchglobal'

//export const baseApiUrl = 'http://localhost:3000'
//export const baseApiUrl = 'http://165.232.56.167/api/'
export const baseApiUrl = 'https://app-concepthomeie.com/api/'

export function showError(e) {
    if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({
            msg: e.response.data
        })
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultError({
            msg: e
        })
    } else {
        Vue.toasted.global.defaultError()
    }
}


export default {
    baseApiUrl,
    showError,
    userKey,
    companykey,
    searchglobalkey
}